import React from 'react'
import ReactDOM from 'react-dom'
import "../assets/css/frontend.scss"
import { animate, inView } from "framer-motion/dom"

const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    console.log(entry)
    if (entry.isIntersecting) {
      entry.target.classList.add('anim-hidden');
      entry.target.classList.add('anim-show');
    } else {
      entry.target.classList.add('anim-hidden');
      entry.target.classList.remove('anim-show');
    }
  });
});

const hiddenAnimElements = document.querySelectorAll('.anim-hidden');
hiddenAnimElements.forEach((el) => observer.observe(el));

// Framer Motion animations for animated container blocks
document.addEventListener("DOMContentLoaded", function() {
  const containers = document.querySelectorAll(".framer-animated-container")
  
  containers.forEach(container => {
    const animationType = container.getAttribute("data-animation-type") || "fadeIn"
    const duration = parseFloat(container.getAttribute("data-animation-duration")) || 0.5
    const delay = parseFloat(container.getAttribute("data-animation-delay")) || 0
    
    // Get initial animation state based on type
    function getInitialState(type) {
      const states = {
        fadeIn: { opacity: 0 },
        slideUp: { opacity: 0, y: 50 },
        slideDown: { opacity: 0, y: -50 },
        slideLeft: { opacity: 0, x: 50 },
        slideRight: { opacity: 0, x: -50 },
        scale: { opacity: 0, scale: 0.8 },
        rotate: { opacity: 0, rotate: -180 }
      }
      return states[type] || states.fadeIn
    }
    
    function getFinalState(type) {
      const states = {
        fadeIn: { opacity: 1 },
        slideUp: { opacity: 1, y: 0 },
        slideDown: { opacity: 1, y: 0 },
        slideLeft: { opacity: 1, x: 0 },
        slideRight: { opacity: 1, x: 0 },
        scale: { opacity: 1, scale: 1 },
        rotate: { opacity: 1, rotate: 0 }
      }
      return states[type] || states.fadeIn
    }
    
    const initialState = getInitialState(animationType)
    const finalState = getFinalState(animationType)
    
    // Set initial state
    container.style.opacity = initialState.opacity !== undefined ? initialState.opacity : 1
    if (initialState.y !== undefined) container.style.transform = `translateY(${initialState.y}px)`
    if (initialState.x !== undefined) container.style.transform = `translateX(${initialState.x}px)`
    if (initialState.scale !== undefined) container.style.transform = `scale(${initialState.scale})`
    if (initialState.rotate !== undefined) container.style.transform = `rotate(${initialState.rotate}deg)`
    
    // Animate when element comes into view
    inView(container, (info) => {
      const cleanup = animate(container, finalState, {
        duration: duration,
        delay: delay,
        ease: "easeOut"
      })
      return cleanup
    })
  })
})

// Javascript for Parallax behavior on the Parallax Block
